<div class="picker-container" #colorElement (mousedown)="$event.preventDefault(); $event.stopPropagation()">
    <div
        *ngFor="let color of colorList"
        [class.selectedColor]="selectedColorHex == color"
        class="color-wrapper"
        (click)="colorSelected(color); $event.stopPropagation()">
        <div class="color" [ngStyle]="{ backgroundColor: color }"></div>
    </div>
</div>
